import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { cancelAppInstallMutate } from 'queries';
import { reducer } from 'actions/registry/fetch-installed-apps';
import { setSelectedClock, triggerAppSync } from 'actions/gallery';

export default new AsyncActionHandler({
  name: 'cancel_app_install',
  stateProp: 'cancelAppInstall',
  handler: (id) => async (dispatch, getState) => {
    const {
      gallery: {
        deviceInfo: { wireId }
      }
    } = getState();
    const { data: response } = await apollo.mutate({
      mutation: cancelAppInstallMutate,
      variables: {
        id,
        wireId
      }
    });

    await dispatch(setSelectedClock(null));
    await dispatch(triggerAppSync({ force: true }));

    return {
      entries: response.cancelAppInstall
    };
  },
  reduce: reducer
});
